__webpack_require__.p = "https://gsm-edge-uat-ui.gsm-tech-prod.nikecloud.com/";